export default "__VITE_ASSET__DgpG9lb2__$_?url__"